import './CartListTemplate.css';
import FirstImg from '../../../assets/image/General news logo_0.png';
import SecImg from '../../../assets/image/General news logo.png';
import ThirdImg from '../../../assets/image/General news logo (2).png';

const CartListTemplate = () => {
    return ( 
        <div className="cartlisttemplate">
            <div className="cartlist">
                <div className="left">
                <img src={FirstImg} alt="news" />
                <h6>News Channel Name 1</h6>
                </div>

                {/* <div className="price">
                    <h6>$8.56</h6>
                </div> */}
            </div>

            <hr />
            
            <div className="cartlist">
                <div className="left">
                <img src={SecImg} alt="news" />
                <h6>News Channel Name 2</h6>
                </div>

                {/* <div className="price">
                    <h6>$6.00</h6>
                </div> */}
            </div>

            <hr />

            <div className="cartlist">
                <div className="left">
                <img src={ThirdImg} alt="news" />
                <h6>News Channel Name 3</h6>
                </div>

                {/* <div className="price">
                    <h6>$6.00</h6>
                </div> */}
            </div>


        </div>
     );
}
 
export default CartListTemplate;